import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// When the HTML was produced by scripts/prerender.js, hydrate it instead of
// re-rendering — so crawlers see real content and users get a flash-free boot.
const isPrerendered =
  document.documentElement.getAttribute("data-prerendered") === "true" ||
  (container && container.innerHTML.trim().length > 0);

const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (isPrerendered) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}
